<template>
<div>
    <div class="employee-search" v-if="!reporteeList">
        <loader-component></loader-component>
    </div>
    <div class="employee-search" v-else>
        <div class="px-2">
            <Input placeholder="Search by name or role" type="text" v-model="userSearchTerm" />
            <!-- <p> Ashok or intern</p> -->
        </div>
        <hr class="divider mt-2" />
        <div class="employee-list" v-if="reporteeList.length>0">
            <div
                :class="[
                    'list-entity d-flex gap-2 justify-content-start align-items-center px-2 py-1',
                    activeUser == user.id ? 'active-user' : '',
                ]"
                v-for="(user, index) in reporteeList"
                :key="index"
                @click="handleUser(user)"
            >
                <img class="qb-avatar" :src="user.profileImg" v-if="user.profileImg" alt="employee image" />
                <img
                    class="qb-avatar"
                    v-else
                    :src="`https://avatars.dicebear.com/api/initials/${user.name}.svg`"
                    alt="employee image"
                />
                <div>
                    <p class="qb-entity-title">{{ user.name }}</p>
                    <p class="qb-entity-subtitle">
                        {{ structureData(user.designation) }}
                    </p>
                </div>
            </div>
        </div>
         <div v-else>
          <p class="text-center my-2">No Reportees Found</p>
    </div>
    </div>
</div>
</template>

<script>
import Input from './TextFieldComponent.vue';
import LoaderComponent from "./LoaderComponent.vue"
import { createNamespacedHelpers } from 'vuex';
const { mapGetters: userMapGetters, mapActions: userMapActions } = createNamespacedHelpers('User');
const { mapGetters: authMapGetters } = createNamespacedHelpers('Auth');
const { mapActions: trainingMapActions } = createNamespacedHelpers('Training');

export default {
    name: 'ReporteesTrainingPage',
    data() {
        return {
            userSearchTerm: '',
            activeUser: '',
        };
    },
    components: {
        Input,
        LoaderComponent
    },
    computed: {
        ...userMapGetters({
            reporteeList: 'getReporteeList',
        }),
        ...authMapGetters({
            user: 'getUser',
        }),
    },
    methods: {
        ...userMapActions({
            getEmployeeByMangerId: 'GET_EMPLOYEE_BY_MANAGER_ID',
        }),
        ...trainingMapActions({
            getEnrolledTrainingsByUserId: 'GET_WORKSHEETS_BY_USER_ID',
        }),

        structureData(data) {
            return data.replaceAll('_', ' ');
        },
        handleUser(user) {
            this.$router.push({
                name: 'ReporteesTrainingPage',
                query: {
                    reporteeId: user.id,
                },
            });
            this.activeUser = user.id;
            this.getEnrolledTrainingsByUserId({ userId: user.id });
        },
    },
    watch: {
        userSearchTerm() {
            this.getEmployeeByMangerId({ id: this.user.userId, name: this.userSearchTerm });
        },
        reporteeList() {
            if (this.reporteeList.length > 0 && this.activeUser == '') {
                this.activeUser = this.reporteeList[0].id;
                this.getEnrolledTrainingsByUserId({ userId: this.reporteeList[0].id });
                this.$router.push({
                    name: 'ReporteesTrainingPage',
                    query: {
                        reporteeId: this.reporteeList[0].id,
                    },
                });
            }
        },
    },
    created() {
        this.getEmployeeByMangerId({ id: this.user.userId });
        if (this.$route.query.reporteeId) {
            this.activeUser = this.$route.query.reporteeId;
            this.getEnrolledTrainingsByUserId({ userId: this.$route.query.reporteeId });
        }
        // else {
        //   if (this.reporteeList.length > 0) {
        //     this.activeUser = this.reporteeList[0].id;
        //     this.getEnrolledTrainingsByUserId({ userId: this.reporteeList[0].id });
        //     this.$router.push({
        //       name: "ReporteesTrainingPage",
        //       query: {
        //         reporteeId: this.reporteeList[0].id,
        //       },
        //     });
        //   }
        // }
    },
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/color.scss';
@import '../assets/scss/font.scss';
@import '../assets/scss/field.scss';

.employee-list {
    height: 380px;
    overflow-y: scroll;
}

.employee-list::-webkit-scrollbar {
    background: none;
    width: 5px;
}

.employee-list::-webkit-scrollbar-thumb {
    background-color: $light-300;
    border-radius: $field-border-radius;
}

// .employee-search {
//   max-height: 150px;
//   overflow: scroll;
// }

.qb-avatar {
    width: 35px;
    height: 35px;
    border-radius: 100%;
}

.active-user {
    background-color: #f1f1f1;
    border-left: 3px solid #1da8d5;
}

.qb-entity-title {
    color: $dark-200;
    font-size: $font-size-md;
    font-weight: $font-weight-normal-2;
    margin: 0px;
}

.list-entity {
    border-bottom: 1px solid $light-200;

    &:hover {
        background-color: $light-100;
        cursor: pointer;
    }
}

.divider {
    border: 0.5px solid $light-500;
    margin: 0px;
}

.qb-entity-subtitle {
    color: $light-500;
    font-size: $font-size-sm;
    font-weight: $font-weight-normal-1;
    margin: 0px;
}
</style>
